import * as React from 'react';
import TableHead from '@material-ui/core/TableHead';

const CustomTableHead = (props) => {
    return <TableHead {...props} />;
};

export { CustomTableHead as TableHead };
